import React from 'react';

import { SignupVerifierFormStepId } from 'src/constants/auth';
import { useAuthSignupVerifier } from 'src/hooks/auth';

import { AuthPaperBox } from '../AuthPaperBox';

import {
  EmailConfirmationForm,
  InitialStepVerifierForm,
  RelatedCompanyForm,
  VerifierAccountTypeVerifierAdminForm,
  VerifierAttestationsForm,
  VerifierBasicInfoVerifierAdminForm,
  VerifierYourCompanyExistInfoBlock,
} from './components';
import { NoticeToFurnishersForm } from './components/NoticeToFurnishersForm/NoticeToFurnishersForm';

export const SignupVerifierPageForm: React.FC = () => {
  const { formStepperState } = useAuthSignupVerifier();

  const formComponent = React.useMemo(() => {
    switch (formStepperState.currentStepId) {
      case SignupVerifierFormStepId.initial:
        return <InitialStepVerifierForm />;
      case SignupVerifierFormStepId.emailConfirmation:
        return <EmailConfirmationForm />;
      case SignupVerifierFormStepId.relatedCompany:
        return <RelatedCompanyForm />;
      case SignupVerifierFormStepId.choseVerifierAccountType:
        return <VerifierAccountTypeVerifierAdminForm />;
      case SignupVerifierFormStepId.verifierAttestations:
        return <VerifierAttestationsForm />;
      case SignupVerifierFormStepId.verifierBasicInfo:
        return <VerifierBasicInfoVerifierAdminForm />;
      case SignupVerifierFormStepId.noticeToFurnishersVerifier:
        return <NoticeToFurnishersForm />;
      case SignupVerifierFormStepId.yourCompanyExistInfoBlock:
        return <VerifierYourCompanyExistInfoBlock />;
      default:
        return null;
    }
  }, [formStepperState.currentStepId]);

  return (
    <AuthPaperBox sx={authBoxStyles(formStepperState.currentStepId as SignupVerifierFormStepId)}>
      {formComponent}
    </AuthPaperBox>
  );
};

const authBoxStyles = (currentStepId: SignupVerifierFormStepId) =>
  currentStepId === SignupVerifierFormStepId.noticeToFurnishersVerifier ? { maxWidth: 830 } : {};
